<template>
    <organization-and-vehicle/>
</template>

<script>
    import OrganizationAndVehicle from "_private/components/super/systemSetting/organizationManage/OrganizationAndVehicle";

    export default {
        components: {
            OrganizationAndVehicle
        }
    };
</script>
